var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-listado',[_c('page-header',{attrs:{"title":"Tarifas"}},[_c('b-button',{attrs:{"variant":"primary","size":"sm","to":"/tarifas/crear"}},[_c('v-icon',{attrs:{"name":"plus","width":"16"}}),_vm._v(" Crear tarifa ")],1)],1),_c('tabla',{attrs:{"tarifas":_vm.tarifas},on:{"eliminar":_vm.eliminar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }